import { protectedRoutes } from '@/router';
import { getResource } from '@/services/user';
import { resourceState } from '@/store/userStore';
import { storage } from '@/utils/storage';
import { getCurrentUser } from '@/utils/user';
import { useEffect, useRef, useState } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';

interface RouterGuardProps {
    children: React.ReactNode;
}

// 白名单路由，不需要登录即可访问
const whiteList = ['/login', '/createLawyerCard', '/law-firm-config/create'];

const RouterGuard: React.FC<RouterGuardProps> = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [authorized, setAuthorized] = useState(false);
    const { pathname } = location;
    const resource = storage.get('resources') || [];
    const pageAuthId = protectedRoutes.find(i => matchPath(i.path, pathname))

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            if (pageAuthId) {
                // 无权限
                if (!resource.includes(pageAuthId.authId)) {
                    setAuthorized(false);
                    navigate('/');
                    return;
                }
            }
            setAuthorized(true);
        } else {
            if (!whiteList.includes(pathname)) {
                navigate('/login');
            } else {
                setAuthorized(true);
            }
        }
    }, [location.pathname, navigate, resource, pageAuthId]);

    return authorized ? <>{children}</> : null;
};

export default RouterGuard; 
